export default __webpack_public_path__ + "static/char-45-anr-89afe317d30ac7c093dc1060da0409e7.gif";